import { useEffect, useState } from 'react'

/**
 * Two-phase media query: `false` on the server and on the first client render,
 * then the real value after mount, so server and client markup always match.
 */
export const useMediaQuery = (query: string): boolean => {
    const [matches, setMatches] = useState(false)

    useEffect(() => {
        const list = window.matchMedia(query)
        const update = () => setMatches(list.matches)

        update()
        list.addEventListener('change', update)

        return () => list.removeEventListener('change', update)
    }, [query])

    return matches
}

export const usePrefersReducedMotion = (): boolean => useMediaQuery('(prefers-reduced-motion: reduce)')

export const useFinePointer = (): boolean => useMediaQuery('(hover: hover) and (pointer: fine)')
